import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import MenuLayout from "../../../layouts/MenuLayout";
import { useDispatch, useSelector } from "react-redux";
import BootCampLayout from "../../../layouts/BootCampLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BootcampPage from "../../../components/Modals/common/bootcamp/BootcampPage";
import { fetchBootcampDetails } from "../../../redux/features/admin/actions/authAction";

const BootcampDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  // const id = useLocation()?.state?.id || "";
  const data = useLocation()?.state?.data2 || "";
  const paginatedList = useLocation()?.state?.data || [];
  const { isLoading, bootCampData } = useSelector((state) => state.admin.auth);

  const [currentId, setCurrentId] = useState(id);
  const [updateBootCampData, setUpdateBootCampData] = useState(
    bootCampData ?? {}
  );

  useEffect(() => {
    dispatch(fetchBootcampDetails({ payload: id }));
  }, []);

  useEffect(() => {
    setUpdateBootCampData(bootCampData ?? {});
  }, [bootCampData]);

  // const handleClickNext = () => {
  //   if (!paginatedList || paginatedList.length === 0) return;
  //   const currentIndex = paginatedList.findIndex(
  //     (item) => item.bootcamp_id === currentId
  //   );
  //   if (currentIndex < paginatedList.length - 1) {
  //     const nextId = paginatedList[currentIndex + 1].bootcamp_id;
  //     setUpdateBootCampData(paginatedList[currentIndex + 1])
  //     setCurrentId(nextId);
  //   }
  // };

  // const handleClickPrevious = () => {
  //   if (!paginatedList || paginatedList.length === 0) return;
  //   const currentIndex = paginatedList.findIndex(
  //     (item) => item.bootcamp_id === currentId
  //   );
  //   if (currentIndex > 0) {
  //     const prevId = paginatedList[currentIndex - 1].bootcamp_id;
  //     setUpdateBootCampData(paginatedList[currentIndex - 1])
  //     setCurrentId(prevId);
  //   }
  // };

  const handleClickNext = () => {
    if (!paginatedList || paginatedList.length === 0) return;
    const currentIndex = paginatedList.findIndex(
      (item) => item.bootcamp_id === currentId
    );
    const nextIndex = (currentIndex + 1) % paginatedList.length;
    const nextItem = paginatedList[nextIndex];
    setUpdateBootCampData(nextItem);
    setCurrentId(nextItem.bootcamp_id);

    navigate(`/bootcamp-detail/${nextItem.bootcamp_id}`, {
      state: {
        id: nextItem.bootcamp_id,
        data2: data == "landing" ? "landing" : "",
        data: paginatedList,
      },
    });
  };

  const handleClickPrevious = () => {
    if (!paginatedList || paginatedList.length === 0) return;
    const currentIndex = paginatedList.findIndex(
      (item) => item.bootcamp_id === currentId
    );
    const prevIndex =
      (currentIndex - 1 + paginatedList.length) % paginatedList.length;
    const prevItem = paginatedList[prevIndex];
    setUpdateBootCampData(prevItem);
    setCurrentId(prevItem.bootcamp_id);

    navigate(`/bootcamp-detail/${prevItem.bootcamp_id}`, {
      state: {
        id: prevItem.bootcamp_id,
        data2: data == "landing" ? "landing" : "",
        data: paginatedList,
      },
    });
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      {data == "landing" ? (
        <MenuLayout>
          <BootcampPage
            bootCampData={updateBootCampData}
            handleClickNext={handleClickNext}
            handleClickPrevious={handleClickPrevious}
          />
        </MenuLayout>
      ) : (
        <BootCampLayout>
          <BootcampPage
            bootCampData={updateBootCampData}
            handleClickNext={handleClickNext}
            handleClickPrevious={handleClickPrevious}
          />
        </BootCampLayout>
      )}
    </>
  );
};

export default BootcampDetail;
